const initialState = {
  account: [],
  allAccount: [],
};

export const account_reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ACCOUNTS":
      return {
        ...state,
        account: action.payload,
      };
    case "GET_ALL_ACCOUNTS":
      return {
        ...state,
        allAccount: action.payload,
      };
    default:
      return state;
  }
};
